/**
 * Basket lifecycle locks (can_edit_request) apply only to role 0 — consultant & customer service.
 * Admin (7) and other roles are not blocked by can_edit_request from the API.
 */
export default {
  computed: {
    viewerRole() {
      const fromData = this.CurrentRole != null && this.CurrentRole !== "";
      const raw = fromData ? this.CurrentRole : window.localStorage.getItem("role");
      return parseInt(raw || "0", 10);
    },

    isCustomerServiceViewer() {
      return (
        this.viewerRole === 0 &&
        window.localStorage.getItem("is_customer_service") === "1"
      );
    },

    isConsultantViewer() {
      return this.viewerRole === 0 && !this.isCustomerServiceViewer;
    },

    lifecycleBasketLockApplies() {
      return this.viewerRole === 0;
    },

    isSystemAdminViewer() {
      return this.viewerRole === 7 || !!window.localStorage.getItem("isAdmin");
    },

    cannotUpdateRequest() {
      if (this.isSystemAdminViewer) return false;
      if (!this.lifecycleBasketLockApplies) return false;
      return !!(this.agent && this.agent.can_edit_request === false);
    },

    requestFieldsDisabled() {
      if (this.isSystemAdminViewer) return false;
      if (!this.lifecycleBasketLockApplies) {
        return !this.for_agent;
      }
      return this.cannotUpdateRequest || !this.for_agent;
    },

    requestTabsDisabled() {
      return false;
      // // for_agent only reflects statusReq 0/1/2/4 — not valid for admin & other roles.
      // if (!this.lifecycleBasketLockApplies) return false;
      // if (this.agent && typeof this.agent.can_open_request === "boolean") {
      //   return !this.agent.can_open_request;
      // }
      // return !this.for_agent;
    },
  },
};

/** For tab child components (FundData, attachments, …) without CurrentRole in data. */
export function isRequestFormDisabled(agent, forAgentFnResult) {
  const role = parseInt(window.localStorage.getItem("role") || "0", 10);
  if (role === 7 || window.localStorage.getItem("isAdmin")) {
    return false;
  }
  if (role !== 0) {
    return !forAgentFnResult;
  }
  return !!(agent && agent.can_edit_request === false) || !forAgentFnResult;
}
